import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';

interface ValidationErrorPanelProps {
  errors: string[];
}

export const ValidationErrorPanel: React.FC<ValidationErrorPanelProps> = ({ errors }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Paper
        className="validation-error"
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          mx: { xs: 2, md: 0 },
          background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
          borderRadius: 4,
          border: '1px solid #fca5a5',
          boxShadow: '0 4px 20px 0 rgba(239, 68, 68, 0.1)',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#dc2626',
            fontWeight: 700,
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          ⚠️ 입력 정보를 확인해주세요
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          {errors.map((error, index) => (
            <Typography
              key={index}
              component="li"
              sx={{
                color: '#dc2626',
                fontWeight: 500,
                mb: 0.5,
                fontSize: 14
              }}
            >
              {error}
            </Typography>
          ))}
        </Box>
      </Paper>
    </motion.div>
  );
}; 